import Grid from "@mui/material/Grid";

import ArgonBox from "component/Argon/ArgonBox";
import ArgonTypography from "component/Argon/ArgonTypography";

import PageLayout from "layout/LayoutContainers/PageLayout";

import typography from "assets/theme/base/typography";

import bgImage from "assets/images/illustrations/error-500.jpg";
import { IconButton } from "@mui/material";


function Maintenance() {
  const { d1, d3, d4, d5 } = typography;

  return (
    <PageLayout white>
      <ArgonBox
        minHeight="100vh"
        sx={{
          display: "grid",
          placeItems: "center",
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
        }}
      >
        <Grid container justifyContent="center">
          <Grid item xs={12} md={7} lg={6} sx={{ textAlign: "center", mx: "auto" }}>
            <ArgonBox
              color="dark"
              fontWeight="bold"
              fontSize={{ xs: d5.fontSize, sm: d4.fontSize, md: d3.fontSize, lg: d1.fontSize }}
              lineHeight={1.2}
              mb={2}
            >
              ระบบกำลังทำการปรับปรุง
            </ArgonBox>
            <ArgonTypography variant="h2" color="dark" fontWeight="bold">
              กำลังจะกลับมาในอีกซักครู่ เพื่อความสะดวกกรุณาติดต่อ
            </ArgonTypography>
            <ArgonBox mt={3}>
              <IconButton href='https://liff.line.me/1645278921-kWRPP32q/?accountId=277fakaj'>
                <ArgonBox sx={{
                  minWidth: 64,
                  minHeight: 64,
                  backgroundImage: `url(https://tkrbroker.com/wp-content/uploads/2022/09/LINE_Brand_icon-1.png)`,
                  backgroundSize: "cover",
                  backgroundPosition: "50%",
                }} />
              </IconButton>
            </ArgonBox>
          </Grid>
        </Grid>
      </ArgonBox>
    </PageLayout >
  );
}

export default Maintenance;
